import { IconButton, Stack } from "@mui/material";
import React, { useState } from "react";
import TitleIcon from "@mui/icons-material/Title";
import { addDoc, collection, doc, updateDoc } from "firebase/firestore";
import { db } from "firebaseApp";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { HEADER_TYPE } from "components/ai-editor/sections/Header";
import SegmentIcon from "@mui/icons-material/Segment";
import { PARAGRAPH_TYPE } from "components/ai-editor/sections/Paragraph";
import AbcIcon from "@mui/icons-material/Abc";
import { MARKDONW_TYPE } from "components/ai-editor/sections/Markdown";
import { IMAGE_TYPE } from "components/ai-editor/sections/Image";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { AI_TYPE } from "components/ai-editor/sections/AIBlock";
import ImageIcon from "@mui/icons-material/Image";
import SendToGoogleDoc from "./SendToGoogleDoc";
import SetGoogleDocumentWithPopupId from "../../google-docs/SetGoogleDocumentWithPopupId";
import { useDocumentData } from "react-firebase-hooks/firestore";
import toast from "react-hot-toast";
import { NOTE_ICON, NOTE_TYPE } from "components/ai-editor/sections/Note";

export default function SectionControls({ documentId }) {
  const auth = useAuth();
  const uid = auth.currentUser?.uid;

  const docRef = documentId ? doc(db, "documents", documentId) : null;
  const [documentData, loading, error] = useDocumentData(docRef);

  const [saving, setSaving] = useState(false);

  if (error) {
    console.log(error);
  }

  const handleCreate = (type) => async () => {
    const data = {
      type: type.key,
      index: new Date().getTime(),
      uid,
      documentId,
      ...type.default,
    };
    console.log(data);
    await addDoc(collection(db, "documents", documentId, "sections"), data);
  };

  const updateGoogleDocumentId = async (googleDocId) => {
    try {
      if(googleDocId === documentData?.googleDocId) return;
      setSaving(true);
      await updateDoc(docRef, {
        googleDocId,
      });
      toast.success("Google doc ID saved!");
    } catch(error) {
      toast.error("Couldn't save Google doc ID");
      console.log(error);
    } finally {
      setSaving(false);
    }
  };

  if(!documentId) return null;

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      py={2}
    >
      <Stack direction="row" spacing={1}>
        <IconButton onClick={handleCreate(HEADER_TYPE)}>
          <TitleIcon />
        </IconButton>
        <IconButton onClick={handleCreate(PARAGRAPH_TYPE)}>
          <AbcIcon />
        </IconButton>
        <IconButton onClick={handleCreate(MARKDONW_TYPE)}>
          <SegmentIcon />
        </IconButton>
        <IconButton onClick={handleCreate(IMAGE_TYPE)}>
          <ImageIcon />
        </IconButton>
        <IconButton onClick={handleCreate(AI_TYPE)}>
          <AutoAwesomeIcon />
        </IconButton>
        <IconButton onClick={handleCreate(NOTE_TYPE)}>
          {NOTE_TYPE.icon}
        </IconButton>
      </Stack>
      <Stack direction="row">
        {documentData && (
          <SetGoogleDocumentWithPopupId
            googleDocId={documentData.googleDocId}
            onSave={updateGoogleDocumentId}
            processing={saving}
          />
        )}

        <SendToGoogleDoc
          documentId={documentId}
          googleDocId={documentData?.googleDocId}
        />
      </Stack>
    </Stack>
  );
}
